<template>
  <div class="card p-0 mb-2 text-sm lg:text-base">
    <div class="p-4" v-html="mistake.question.text.substring(0, 60) + '...'"></div>
    <div class="p-4 border-t border-b text-xs text-gray-700">
      <div class="lg:flex justify-between items-center gap-4">
        <div class="flex justify-between mb-3">
          <tendency :value="mistake.tendency" class="mr-2"/>
          <div class="badge badge-secondary">Fehler vom: {{ moment(mistake.created_at).format('DD.MM.YYYY') }}</div>
        </div>
        <div class="flex flex-col lg:flex-row lg:inline-flex rounded-md shadow-sm" role="group">
          <button @click="openDetails" type="button"
                  class="py-2 px-4 text-sm font-medium text-gray-900 bg-white rounded-l-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            <i class="fa fa-info-circle mr-2"></i> Details
          </button>
          <button @click="$emit('remove', mistake )" type="button"
                  class="py-2 px-4 text-sm font-medium text-gray-900 bg-white rounded-r-md border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            <i class="fa fa-thumbs-up mr-2"></i> {{ __('mistakes.mark_as_learned') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tendency from './Tendency'
import moment from 'moment'

export default {
  name: 'MistakeItem',

  components: {
    Tendency,
  },

  props: {
    mistake: {
      type: Object,
      required: true,
    },
  },
  emits: ['details', 'remove'],

  data() {
    return {
      moment: moment,
    }
  },

  methods: {
    openDetails: function () {
      this.$emit('details', this.mistake)
    },
  },
}
</script>

